<div
  class="h-[68px] w-full bg-white border border-gris-3 rounded-[5px] flex items-center px-[10px] gap-[10px] shrink-0"
>
  <!-- Icône catégorie -->
  <div
    class="size-[48px] rounded-[5px] shrink-0 relative overflow-hidden"
    [style.background]="bgColor()"
  >
    @if (imageUrl()) {
      <img [src]="imageUrl()" class="absolute inset-0 w-full h-full object-contain" alt="" />
    }
  </div>
  <!-- Infos -->
  <div class="flex flex-col flex-1 min-w-0">
    <span class="text-[14px] font-semibold fg-noir-2 leading-tight truncate">
      {{ serviceName() }}
    </span>
    <span class="text-[14px] fg-noir-2 leading-tight truncate">{{ course().name }}</span>
  </div>
  <!-- Prix + quantité -->
  <div class="flex flex-col items-end shrink-0">
    <span class="text-[14px] fg-gris-2">
      {{ 'summary_course_card.quantity' | translate: { count: quantity() } }}
    </span>
    <span class="text-[14px] font-semibold fg-gris-1">
      @if (!showPrice()) {
        {{ 'order.included' | translate }}
      } @else {
        {{ course().price ?? 0 | formatPrice }}
      }
    </span>
  </div>
  <!-- Bouton supprimer -->
  @if (showRemoveButton()) {
    <button
      type="button"
      (click)="remove.emit()"
      [disabled]="disabled()"
      class="size-[48px] rounded-[5px] border border-gris-3 flex items-center justify-center transition-colors shrink-0"
      [class.bg-gris-4]="!disabled()"
      [class.hover:bg-gris-3]="!disabled()"
      [class.cursor-pointer]="!disabled()"
      [class.bg-gris-3]="disabled()"
      [class.cursor-not-allowed]="disabled()"
    >
      <app-svg class="fg-gris-1" height="20" svgPath="assets/svg/trash.svg" width="20" />
    </button>
  }
</div>
